import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Fade } from "react-awesome-reveal";
import RituSharmaImage from '../../assets/RITU-SHARMA.png';
import linkedin from '../../assets/linkedin.svg';
import ShreyasPanditImage from '../../assets/SHREYAS-PANDIT.png';

const teamData = [
  {
    img: RituSharmaImage,
    name: 'RITU SHARMA',
    title: 'CO-FOUNDER',
    linkedin: 'https://www.linkedin.com/in/ritu-sharma-1298202ab/', // Add actual LinkedIn URL
    description: 'With over a decade of experience in trading, investments, and research analysis, Ritu Sharma brings deep market expertise and analytical acumen. As an NISM-certified professional, she is committed to delivering well-researched insights to empower smarter investment decisions.'
  },
  {
    img: ShreyasPanditImage,
    name: 'SHREYAS PANDIT',
    title: 'CO-FOUNDER',
    linkedin: 'https://www.linkedin.com/in/shreyaspandit', // Add actual LinkedIn URL
    description: 'A seasoned business leader with 15+ years of experience, Shreyas Pandit has led sales, category management, and growth for top Indian platforms. An NISM-certified professional with expertise in research analysis, he combines market insights with a strong profitability focus to drive informed investment strategies.'
  }
];

function TeamSection() {
  return (
    <div className="team-section section-padding">
      <Container className="text-center">
        <Fade triggerOnce direction="down">
          {/* <p className="text-light-blue mb-2">Meet the Team</p> */}
                      <h2 className="contact-section-title">Who We Are?</h2>
        </Fade>

        <Row xs={1} md={2} className="g-4 mt-4 justify-content-between">
          {teamData.map((member, index) => (
            <Col key={index} lg={5} className='h-100'> {/* Adjust Col size for desired width */}
              <Fade triggerOnce delay={index * 150} cascade={false} direction="up" className="h-100">
                <Card className="h-100">
                  <Card.Img variant="top" src={member.img} alt={member.name} />
                  <Card.Body>
                    <p className="team-member-title">
                      {member.name}, {member.title}
                      {/* Accessible name on the icon-only link (audit round-3);
                          icon itself is decorative */}
                      <a
                        href={member.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="linkedin-icon"
                        aria-label={`${member.name} on LinkedIn`}
                      ><img src={linkedin} alt="" aria-hidden="true" /></a>
                    </p>
                    <Card.Text className='team-member-desc'>{member.description}</Card.Text>
                  </Card.Body>
                </Card>
              </Fade>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default TeamSection;